import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ overline, title, sub, testId }) => (
  <div className="max-w-2xl" data-testid={testId}>
    <Reveal>
      <p className="text-xs uppercase tracking-[0.25em] font-bold text-primary">{overline}</p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="mt-4 font-display text-4xl md:text-5xl tracking-tight font-medium leading-[1.05]">{title}</h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.16}>
        <p className="mt-5 text-base md:text-lg leading-relaxed text-muted-foreground">{sub}</p>
      </Reveal>
    )}
  </div>
);
